module.exports = __webpack_public_path__ + "static/media/bar-method.df4245f0.svg";